import { TapeChartCreateTapeStore } from '@new/domains/fastBookingsTapeChart/stores/TapeChartCreateTapeStore'

export const tapeChartCreateTapeStore = TapeChartCreateTapeStore
